import { render } from "./InvalidElement.vue.js?vue&type=template&id=50967ba1&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InvalidElement.vue?vue&type=template&id=50967ba1&scoped=true"
import script from "./InvalidElement.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InvalidElement.vue?vue&type=script&lang=js"
export * from "./InvalidElement.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InvalidElement.vue?vue&type=script&lang=js"

import "./InvalidElement.vue.scss?vue&type=style&index=0&id=50967ba1&scoped=true&lang=scss!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InvalidElement.vue?vue&type=style&index=0&id=50967ba1&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50967ba1"],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/InvalidElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50967ba1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50967ba1', __exports__)) {
    api.reload('50967ba1', __exports__)
  }
  
  module.hot.accept("./InvalidElement.vue.js?vue&type=template&id=50967ba1&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InvalidElement.vue?vue&type=template&id=50967ba1&scoped=true", () => {
    api.rerender('50967ba1', render)
  })

}


export default __exports__